import { Component, EventEmitter, OnInit, Output, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Employee } from '@coin/shared/core/util-models';
import { ActionDef, Store } from '@ngxs/store';
import { SetCurrentLevel } from '../../../../merit/merit-budget-allocation/store/merit-budget-allocation-total.actions';
import { MeritBudgetAllocationState } from '../../../../merit/merit-budget-allocation/store/merit-budget-allocation.state';
import { OrganisationService } from '../../../models/organisation-service.model';

@Component({
  selector: 'customer-org-tree-overview-item',
  templateUrl: './org-tree-overview-item.component.html',
  styleUrls: ['./org-tree-overview-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrgTreeOverviewItemComponent implements OnInit {
  private store = inject(Store);

  readonly head = input<Employee>(undefined);
  readonly level = input<number>(undefined);
  readonly last = input<boolean>(undefined);
  readonly lastParent = input<boolean>(undefined);
  readonly selectedEmployeeId = input<string>(undefined);
  readonly customOpenEmployeeInViewAction = input<ActionDef>(undefined);
  readonly service = input<OrganisationService>(undefined);
  readonly seasonId = input<string>(undefined);
  @Output() clickTreeItem = new EventEmitter<void>();

  private maxVisibleLevel: number;

  get disableNavigation(): boolean {
    return this.maxVisibleLevel && this.level() >= this.maxVisibleLevel;
  }

  get isRoot(): boolean {
    return this.level() === 0;
  }

  get isMaxLevel(): boolean {
    return this.level() === 2;
  }

  get isSelected(): boolean {
    return this.head()?.id === this.selectedEmployeeId();
  }

  ngOnInit(): void {
    this.maxVisibleLevel = this.store.selectSnapshot(MeritBudgetAllocationState.allocationSettings)?.visibleLevels;
  }

  public onClickItem(): void {
    if (!this.disableNavigation) {
      let isFullTree = true;
      if (this.maxVisibleLevel) {
        const level = this.head().orgCode === 'SE GP' ? this.level() : this.level() + 1;
        this.store.dispatch(new SetCurrentLevel({ level }));
        isFullTree = false;
      }
      this.store.dispatch(new (this.customOpenEmployeeInViewAction())({ node: this.head(), fullTree: isFullTree }));
      this.clickTreeItem.emit();
    }
  }
}
